import { ActionComponentProps } from "@flow/frontend/member/plugin_api";
import { ActionCustomData } from "../../common/action_types";
import { Box, Button, Stack, Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { ActionComponentWrapper } from "@flow/frontend/member/components/ActionComponentWrapper";
import { memberTheme } from "@flow/frontend/member/memberTheme";

export function HtmlActionComponent(props: ActionComponentProps<ActionCustomData>) {
  const nextStep = () => {
    props.dispatch.gotoNextStep("completed", props.ctx, props.consents || []);
  };
  return (
    <ActionComponentWrapper>
      <Stack spacing={3}>
        <Typography variant="h6" color={memberTheme.palette.primary.main}>
          {props.custom.title}
        </Typography>
        <Box dangerouslySetInnerHTML={{ __html: props.custom.body }}></Box>
        <Button onClick={nextStep}>
          {props.custom.nextButtonText || "Next"} {<ChevronRightIcon sx={{ paddingLeft: "10px" }} />}
        </Button>
      </Stack>
    </ActionComponentWrapper>
  );
}
